import index from './en-us/index.js'
import login from './en-us/login.js'
import main from './en-us/main.js'
// common/check..
import status from './en-us/base/status.js'
import base from './en-us/base/base.js'

import notFound from './en-us/notFound.js'

//后台数据国际化
import i18nMain from './en-us/dataI18n/main.js'
import i18nStatus from './en-us/dataI18n/status.js'
import i18nInsuranceStatus from './en-us/dataI18n/insuranceStatus.js'


// 发票相关
import invoice_apply from './en-us/invoice_apply.js'
import invoice from './en-us/invoice.js'

//条款
import invoiceClause from './en-us/clause/invoiceClause.js'

// 修改个人信息
import modifyInfo from './en-us/modifyInfo.js'

// 展位相关
import chooseBooth from './en-us/chooseBooth.js'
import boothInfo from './en-us/boothInfo'
//施工图
import drawingsDetail from './en-us/drawings/drawingsDetail'
import drawingsIndex from './en-us/drawings/drawingsIndex'
import drawingsNotice from './en-us/drawings/drawingsNotice'
import drawingsBoothConfirm from './en-us/drawings/drawingsBoothConfirm'
import drawings from './en-us/drawings/drawings'
import drawingsBoothInfo from './en-us/drawings/drawingsBoothInfo'
import drawingsProducerInfo from './en-us/drawings/drawingsProducerInfo'
import drawingsUpload from './en-us/drawings/drawingsUpload'
import drawingsCarpet from './en-us/drawings/drawingsCarpet'
import drawingsEnd from './en-us/drawings/drawingEnd'
//楣板
import fascia from './en-us/fascia'

//承建商相关
import constructionPermit from './en-us/constructionPermit'

//缴费
import fee from './en-us/fee.js'
import feeConfirmation from './en-us/feeConfirmation.js'
import feeOfflinePayment from './en-us/feeOfflinePayment'
import fixedFee from './en-us/fixedFee.js'
import foregift from './en-us/foregift.js'
import order from './en-us/order'
import order_info from './en-us/order_info.js'
import shopList from './en-us/shopList.js'
import foodList from './en-us/foodList.js'
import SettlementList from './en-us/SettlementList'

//展位保险
import insuranceHome from './en-us/insuranceHome'


import booklet from './en-us/booklet'
import carLicenseApply from './en-us/carLicenseApply'
import qrCode from './en-us/qrCode'

//发票
import invoiceConfirmation from './en-us/invoiceConfirmation'


export default {
	invoiceClause,
	qrCode,
	status,
	base,
	drawingsCarpet,
	drawingsUpload,
	drawingsProducerInfo,
	drawings,
	drawingsBoothInfo,
	drawingsEnd,
	login,
	index,
	invoice_apply,
	invoice,
	modifyInfo,
	chooseBooth,
	shopList,
	foodList,
	fee,
	fixedFee,
	feeConfirmation,
	foregift,
	main,
	order_info,
	order,
	fascia,
	booklet,
	drawingsNotice,
	drawingsIndex,
	drawingsDetail,
	carLicenseApply,
	constructionPermit,
	insuranceHome,
	boothInfo,
	feeOfflinePayment,
	drawingsBoothConfirm,
	i18nMain,
	invoiceConfirmation,
	SettlementList,
	i18nStatus,
	i18nInsuranceStatus,
	invoiceConfirmation,
	notFound
}



// WEBPACK FOOTER //
// ./src/i18n/en-us.js